import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { AddressesService } from 'src/app/pages/addresses/services/addresses.service';
import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { normalizeText } from '../utilities/utils';
import { v4 as uuidv4 } from 'uuid';
import { LatLng } from 'src/app/pages/new-service/interfaces/LongitudeLatitude';


interface AddressOption {
  icon?: string | undefined;
  name?: string | undefined;
  address?: string | undefined;
  googleMapsAddress?: boolean | undefined;
}

export interface AddressLatLng {
  Address: string | undefined;
  Lat: number | undefined;
  Lng: number | undefined;
  googleMapsAddress?: boolean | undefined;
  addressId: string | null;
  addressKey: string | null;
}

export interface StoredAddressRequest {
  Addresses: StoredAddress[];
}

export interface StoredAddress {
  Address: string;
  AddressDetails: string;
  AddressKey: string;
  AddressLatitude: number;
  AddressLongitude: number;
  AddressType: number;
  Category: number;
  ContactEmail: string;
  ContactLastName: string;
  ContactName: string;
  ContactPhone: string;
  Id: string;
  IsFavorite: boolean;
  IsInternalContact: boolean;
  Notes: string;
  ZoneId: string;
}

export interface StoredAddressEmit extends StoredAddress {
  Lat: number | undefined;
  Lng: number | undefined;
  googleMapsAddress?: boolean | undefined;
}

@Component({
  selector: 'app-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss']
})
export class AddressInputComponent {

  uniqueId: string = uuidv4();

  StoredAddress: StoredAddress[] = []

  @Input()
  address: string | undefined = '';

  // addressId: string | undefined = '';

  @Input()
  latitude: number = 0;

  @Input()
  long: number = 0;

  @Input()
  absoluteDropdown: boolean = true;

  @Input()
  placeholder: string = "Carrer del Comte Borrell, 42, 08015 Barcelona, España";

  @Output()
  addressEmitter = new EventEmitter()

  @Output()
  latEmitter = new EventEmitter()

  @Output()
  longEmitter = new EventEmitter()

  @Output()
  addressDataEmitter = new EventEmitter<AddressLatLng>()

  @Output() addressContactDataEmitter = new EventEmitter<StoredAddress>()

  @Output() storedAddressEmitter = new EventEmitter<StoredAddressEmit>()

  suggestions: any[] = [];
  addressesList: AddressOption[] = [];

  addressesListOptions: AddressOption[] = [];
  isGoogleMapsAddress: boolean | undefined = false;
  FullAddressData: StoredAddress | undefined;
  addressId: string | null = null;
  FullAddressDataCompleted: StoredAddressEmit | undefined;

  constructor(private googleMapsService: GoogleMapsService, private addressesService: AddressesService) { }

  ngOnInit() {
    this.getAddressesList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.latitude && this.long && (changes['latitude'] && changes['latitude'].currentValue) || (changes['long'] && changes['long'].currentValue)) {
      this.googleMapsService.getAddressFromLatLong(this.latitude, this.long).then((address: string) => {
        this.address = address;
      })
    }

    if (this.address && (changes['address'] && changes['address'].currentValue)) {
      this.googleMapsService.getLatLongFromAddress(this.address)?.then((result: LatLng) => {
        this.latitude = result.lat ?? 0;
        this.long = result.lng ?? 0
      })
    }
    this.updateAddressList()
  }

  dropdownOpen: boolean = false;

  toggleDropdown() {
    this.dropdownOpen = true;
  }

  getAddressesList() {
    this.addressesService.getAddressesList().subscribe((addresses: StoredAddressRequest) => {
      this.StoredAddress = [...addresses?.Addresses];
      this.addressesList = addresses?.Addresses?.map((address: any) => {
        return {
          icon: `assets/icons/default-address.svg`,
          name: address.AddressKey,
          address: address.Address,
          googleMapsAddress: false
        }
      })
      this.updateAddressList();
    });
  }

  onInputChange(): void {
    if (this.address) {
      this.googleMapsService.getAutocompletePredictions(this.address).then((predictions) => {
        this.suggestions = predictions?.map((prediction: any) => {
          return {
            icon: `assets/icons/location-google-maps-icon.svg`,
            address: prediction?.description,
            googleMapsAddress: true
          }
        })
        this.updateAddressList();
      }).catch((error) => {
        console.error(error);
      });
    } else {
      this.suggestions = [];
      this.address = "";
      this.latitude = 0;
      this.long = 0;
      this.sendData()
    }
  }

  onSuggestionSelected(addressOption: AddressOption): void {
    this.address = addressOption?.address;
    this.isGoogleMapsAddress = addressOption?.googleMapsAddress;
    if (!this.isGoogleMapsAddress) {
      this.FullAddressData = this.StoredAddress.find((address: StoredAddress) => address.Address == addressOption.address)
      if (this.FullAddressData) {
        this.addressId = this.FullAddressData.Id
      }
    } else {
      this.FullAddressData = undefined;
      this.addressId = null;
    }
    this.dropdownOpen = false;
    this.resetAddressList();
    this.getLatLng();
  }

  getLatLng(): void {
    if (this.address) {
      this.googleMapsService.getLatLongFromAddress(this.address)?.then((result) => {
        this.latitude = result.lat ?? 0;
        this.long = result.lng ?? 0;
        this.sendData();
      }).catch((error) => {
        console.error(error);
      });
    }
  }

  sendData() {
    this.addressEmitter.emit(this.address);
    this.latEmitter.emit(this.latitude);
    this.longEmitter.emit(this.long);
    this.addressContactDataEmitter.emit(this.FullAddressData);
    this.storedAddressEmitter.emit(this.FullAddressDataCompleted)
    this.addressDataEmitter.emit({
      Address: this.address,
      Lat: this.latitude,
      Lng: this.long,
      googleMapsAddress: this.isGoogleMapsAddress,
      addressId: this.addressId,
      addressKey: this.FullAddressData?.AddressKey || null
    });

  }

  resetAddressList() {
    let addressListFilter = [...this.addressesList];
    addressListFilter = this.alphabeticSortBynName(addressListFilter)

    this.addressesListOptions = [...addressListFilter, ...this.suggestions];

  }

  updateAddressList() {
    const searchTerm = normalizeText(this.address?.trim().toLowerCase() || '');
    let addressListFilter: AddressOption[] = [];

    if (!searchTerm) {
      addressListFilter = [...this.addressesList];
    } else {
      addressListFilter = this.addressesList.filter((item: AddressOption) => {
        const name = normalizeText(item?.name?.toLowerCase() || '');
        const addr = normalizeText(item?.address?.toLowerCase() || '');
        return name.includes(searchTerm) || addr.includes(searchTerm);
      });
    }
    addressListFilter = this.alphabeticSortBynName(addressListFilter)
    this.addressesListOptions = [...addressListFilter, ...this.suggestions];
  }

  alphabeticSortBynName(address: AddressOption[]): AddressOption[] {
    const sorted = [...address].sort((a, b) => {
      const nameA = (a.name || '').toLowerCase();
      const nameB = (b.name || '').toLowerCase();
      return nameA.localeCompare(nameB);
    })
    return sorted
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const element = document.getElementById(`${this.uniqueId}`);
    if (element && !element.contains(targetElement)) {
      this.dropdownOpen = false;
      this.dropdownOpen = false;
      this.resetAddressList();
    }

  }



}
